import { Routes } from '@angular/router';
import { redirectToAsset } from '@components/guards/redirect-to-asset';
import { Layout } from '@components/layout/layout';

/**
 * Rotas do site. Cada página é carregada sob demanda com `loadComponent`.
 *
 * - As páginas ficam em `children` da rota de layout (header + footer).
 * - `contrato.pdf` sai da SPA e abre `/assets/contrato.pdf`.
 * - A rota `**` (404) fica FORA do layout (sem header e footer) e sempre por último.
 */
export const routes: Routes = [
  {
    path: 'contrato.pdf',
    canActivate: [redirectToAsset('/assets/contrato.pdf')],
    children: [],
  },
  {
    path: '',
    component: Layout,
    // Novas páginas entram neste array (uma por objeto, com `loadComponent` e `title`).
    // Fora dele elas ficam sem header e footer.
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'PinPag | Solução Completa em Meio Eletrônico de Pagamento',
        loadComponent: () => import('@pages/home/home').then((m) => m.Home),
      },
      // Segmentos
      {
        path: 'despachantes-documentalistas',
        title: 'PinPag | Despachantes Documentalistas',
        loadComponent: () =>
          import('@pages/despachantes-documentalistas/despachantes-documentalistas').then(
            (m) => m.DespachantesDocumentalistas,
          ),
      },
      {
        path: 'oficina-mecanica',
        title: 'PinPag | Oficina Mecânica',
        loadComponent: () =>
          import('@pages/oficina-mecanica/oficina-mecanica').then((m) => m.OficinaMecanica),
      },
      {
        path: 'cartorios',
        title: 'PinPag | Cartórios',
        loadComponent: () => import('@pages/cartorios/cartorios').then((m) => m.Cartorios),
      },
      {
        path: 'saude',
        title: 'PinPag | Saúde',
        loadComponent: () => import('@pages/saude/saude').then((m) => m.Saude),
      },
      {
        path: 'educacao',
        title: 'PinPag | Educação',
        loadComponent: () => import('@pages/educacao/educacao').then((m) => m.Educacao),
      },
      {
        path: 'concessionarias',
        title: 'PinPag | Concessionárias',
        loadComponent: () =>
          import('@pages/concessionarias/concessionarias').then((m) => m.Concessionarias),
      },
      // Produtos
      {
        path: 'link-de-pagamento',
        title: 'PinPag | Link de Pagamento',
        loadComponent: () =>
          import('@pages/link-de-pagamento/link-de-pagamento').then((m) => m.LinkDePagamento),
      },
      {
        path: 'checkout-online',
        title: 'PinPag | Checkout Online',
        loadComponent: () =>
          import('@pages/checkout-online/checkout-online').then((m) => m.CheckoutOnline),
      },
      {
        path: 'maquininhas',
        title: 'PinPag | Máquinas de Pagamento',
        loadComponent: () => import('@pages/maquininhas/maquininhas').then((m) => m.Maquininhas),
      },
      // Institucional
      {
        path: 'quem-somos',
        title: 'PinPag | Quem Somos',
        loadComponent: () => import('@pages/quem-somos/quem-somos').then((m) => m.QuemSomos),
      },
      {
        path: 'bom-condutor',
        title: 'PinPag | Bom Condutor',
        loadComponent: () =>
          import('@pages/bom-condutor/bom-condutor').then((m) => m.BomCondutor),
      },
      {
        // Página pai com menu lateral; os títulos ficam em cada seção (faq.routes.ts).
        path: 'faq',
        title: 'PinPag | FAQ',
        loadChildren: () => import('@pages/faq/faq.routes').then((m) => m.faqRoutes),
      },
      {
        path: 'suporte',
        title: 'PinPag | Suporte',
        loadComponent: () => import('@pages/suporte/suporte').then((m) => m.Suporte),
      },
      // Busca de parceiros + consulta de débitos (única página que chama a API)
      {
        path: 'pdv',
        title: 'PinPag | Busca de Parceiros',
        loadComponent: () => import('@pages/pdv/pdv').then((m) => m.Pdv),
      },
    ],
  },
  {
    path: '**',
    title: 'PinPag | Página não encontrada',
    loadComponent: () => import('@pages/not-found/not-found').then((m) => m.NotFound),
  },
];
